import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "../redux/store";
import { setAuth, setInitialized } from "../redux/auth/auth.slice";
import { jwtDecode, setSession } from "./auth.utils";
import { AuthenticatedUser, RoleType } from "../types/user.types";
import { Paths } from "../routes/paths";
import { LOCAL_STORAGE_KEYS } from "../constants/api";
import { safeLogger } from "../utils/logger";
import axiosInstance, { baseURL } from "../services/axios";

const InitializedAuth = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const initialize = async () => {
      try {
        const token = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);

        if (!token) {
          dispatch(setInitialized());
          return;
        }

        setSession(token);
        const decoded = jwtDecode(token);
        safeLogger.log("Initializing auth from stored token");

        const id = decoded["id"];
        const email =
          decoded["email"] ??
          decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
        const role =
          decoded["role"] ??
          decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        const code = decoded["code"];

        if (!id || !email || !role) {
          safeLogger.warn("Token missing required fields");
          dispatch(setInitialized());
          return;
        }

        // --- שימוש נכון ב-axiosInstance ---
        const response = await axiosInstance.get(`${baseURL}/Login/profile`);
        const profile = response.data;

        const name = `${profile.firstName}`.trim();

        const mappedUser: AuthenticatedUser = {
          id,
          email,
          name,
          role: role as RoleType,
          code,
        };

        dispatch(setAuth(mappedUser));
        dispatch(setInitialized());

        // תפקיד → נתיב עיקרי
        const rolePathMap: Record<RoleType, string> = {
          Admin: `/${Paths.adminArea}`,
          Analyst: `/${Paths.analystArea}`,
          Child: `/${Paths.parentArea}`,
        };

        const currentPath = location.pathname;
        const basePath = rolePathMap[mappedUser.role] ?? `/${Paths.home}`;

        // נווט רק אם לא כבר בתוך הנתיב המתאים
        if (!currentPath.startsWith(basePath)) {
          navigate(basePath);
        }
      } catch (err) {
        safeLogger.error("Auth initialization failed");
        dispatch(setInitialized());
      }
    };

    initialize();
  }, [dispatch, navigate, location]);

  return null;
};

export default InitializedAuth;
